import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=6dd6d0c4&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/evaluation.css?vue&type=style&index=0&id=6dd6d0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd6d0c4",
  null
  
)

export default component.exports